import { render, staticRenderFns } from "./MyAccountTopNav.vue?vue&type=template&id=570a1ca0"
import script from "./MyAccountTopNav.vue?vue&type=script&lang=js"
export * from "./MyAccountTopNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports